import styled from "@emotion/styled";
import { BasePage as LibraryBasePage } from "@togglhire/candidate-components";
import React from "react";
import { Footer } from "../footer";

interface BasePageProps {
  embedded?: boolean;
  footer?: boolean;
  children?: React.ReactNode;
}

export function BasePage({ footer = true, ...props }: BasePageProps) {
  return (
    <LibraryBasePage embedded={props.embedded === true}>
      {props.children}
      {footer && (
        <FooterWrapper>
          <Footer />
        </FooterWrapper>
      )}
    </LibraryBasePage>
  );
}

const FooterWrapper = styled.div`
  margin-top: 30px;
`;
